import script from "./contedo-menu.vue?vue&type=script&setup=true&lang=js"
export * from "./contedo-menu.vue?vue&type=script&setup=true&lang=js"

import "./contedo-menu.vue?vue&type=style&index=0&id=3c156f1a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c156f1a"]])

export default __exports__